<template>
  <div style="height: 100%; background-color: #fff; padding-top: 20px">
    <a-row>
      <a-col :span="6" class="period_title">
        <span style="color: red">*</span>期刊名称：
      </a-col>
      <a-col :span="8">
        <a-input
          class="input"
          v-model="periodicalDoc.periodicalName"
          placeholder="请输入"
        />
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="6" class="period_title">
        <span style="color: red">*</span>期刊周期：
      </a-col>
      <a-col :span="8">
        <a-select
          defaultValue="0"
          style="width: 120px"
          v-model="periodicalDoc.cycle"
        >
          <a-select-option value="0">全部</a-select-option>
          <a-select-option value="year">全年刊</a-select-option>
          <a-select-option value="douMon">双月刊</a-select-option>
          <a-select-option value="month">月刊</a-select-option>
          <a-select-option value="halfMon">半月刊</a-select-option>
          <a-select-option value="xunMon">旬刊</a-select-option>
          <a-select-option value="week">周刊</a-select-option>
        </a-select>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="6" class="period_title">
        <span style="color: red">*</span>CN：
      </a-col>
      <a-col :span="8">
        <a-input
          class="input"
          v-model="periodicalDoc.cn"
          placeholder="请输入"
        />
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="6" class="period_title">
        <span style="color: red">*</span>ISSN：
      </a-col>
      <a-col :span="8">
        <a-input
          class="input"
          v-model="periodicalDoc.issn"
          placeholder="请输入"
        />
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="6" class="period_title">联系电话：</a-col>
      <a-col :span="8">
        <a-input
          class="input"
          v-model="periodicalDoc.phone"
          placeholder="请输入"
        />
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="6" class="period_title">电子邮箱：</a-col>
      <a-col :span="8">
        <a-input
          class="input"
          v-model="periodicalDoc.eMail"
          placeholder="请输入"
        />
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="6" class="period_title">办公地址：</a-col>
      <a-col :span="8">
        <a-input
          class="input"
          v-model="periodicalDoc.address"
          placeholder="请输入"
        />
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="8">
        <a-button type="primary" class="submit" @click="submit">保存</a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "periodicalDoc",
  data() {
    return {
      periodicalDoc: { periodicalName: "", cycle: "0", cn: "", issn: "" },
    };
  },
  created() {
    this.query();
  },
  methods: {
    query() {
      this.axios
        .get("/periodicalDoc/queryPeriodicalDoc", {
          params: {
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.periodicalDoc = res.data.data;
            if (this.periodicalDoc.cycle == null) {
              this.periodicalDoc.cycle = "0";
            }
          } else {
            this.utils.messageInfo(this, "error", "查询期刊档案失败！");
          }
        });
    },
    submit() {
      if (this.periodicalDoc.periodicalName == "") {
        this.utils.messageInfo(this, "error", "期刊名称不能为空！");
        return;
      } else if (this.periodicalDoc.cycle == "0") {
        this.utils.messageInfo(this, "error", "请选择期刊周期！");
        return;
      } else if (this.periodicalDoc.cn == "") {
        this.utils.messageInfo(this, "error", "123CN不能为空！");
        return;
      } else if (this.periodicalDoc.issn == "") {
        this.utils.messageInfo(this, "error", "ISSN不能为空！");
        return;
      }

      this.axios
        .post("/periodicalDoc/savePeriodicalDoc", {
          periodicalCode: this.periodicalDoc.periodicalCode,
          periodicalName: this.periodicalDoc.periodicalName,
          cycle: this.periodicalDoc.cycle,
          cn: this.periodicalDoc.cn,
          issn: this.periodicalDoc.issn,
          phone: this.periodicalDoc.phone,
          eMail: this.periodicalDoc.eMail,
          address: this.periodicalDoc.address,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "保存成功");
            this.query();
            this.visible = false;
          } else {
            this.utils.messageInfo(this, "error", "保存失败！");
          }
        });
    },
  },
};
</script>

<style scoped>
.period_title {
  text-align: right;
  line-height: 32px;
}
.input {
  height: 40px;
}
.ant-row {
  margin-bottom: 20px;
}
.submit {
  margin-left: 500px;
  margin-top: 20px;
}
</style>
